import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const TaxOutgoing = () => {
  return (
    <SettingsMetaData propertyName={"Tax_Outgoing"} viewPropertyName={"Tax"} />
  );
};
export default TaxOutgoing;